import { statusState } from "../theme/tokens.js";
import { stateLabel } from "./geo.js";

/* How far through a school is, read off the client's own review gates.
 *
 * The schools layer carries a handful of steps against each school: REC
 * status, FCD status, EHP review, bridging doc, construction status. Those
 * are a record of where a school actually is, kept by the people doing the
 * work, so the app reads them rather than keeping a second answer that would
 * be wrong within a week.
 *
 * A step nobody has filled in counts neither way. The layer writes those as 0
 * or leaves them blank, and treating that as not started would report a
 * school as behind when the truth is that nobody has said. It is left out of
 * both the top and the bottom of the fraction, which is the same rule the map
 * on the Trackers page already uses.
 */

export function gateProgress(row = {}, gateKeys = []) {
  let done = 0;
  let reported = 0;
  for (const key of gateKeys) {
    /* A step counts only where the word means something the app recognises.
       Blank, 0 and N/A all mean nobody has said, and they arrive in all three
       spellings depending on who filled the row in. */
    const state = statusState(stateLabel(row[key]));
    if (!state) continue;
    reported += 1;
    if (state === "complete") done += 1;
  }
  return {
    done,
    reported,
    total: gateKeys.length,
    /* Nought, not nothing, when no step has been filled in. A school nobody
       has reported on has made no recorded progress, which is true, and the
       card says how many steps that is out of. */
    percent: reported > 0 ? Math.round((done / reported) * 100) : 0,
  };
}
